import { useMemo } from 'react';
import useStore from '../context/useStore';
import useOngoingOrder from '../context/useOngoingOrder';
import useOrderBasket from '../context/useOrderBasket';

export default function useDeliveryAmountThreshold() {
  const { storeData } = useStore();
  const { orderData, isDelivery } = useOngoingOrder();
  const { subtotal } = useOrderBasket();

  const minThreshold = isDelivery ? orderData.delivery_info.zone?.min_threshold : null;
  const maxThreshold = isDelivery ? orderData.delivery_info.zone?.max_threshold : null;

  const hasDeliveryAmountThreshold = useMemo(
    () =>
      isDelivery &&
      storeData.order_settings.has_delivery &&
      (minThreshold !== null || maxThreshold !== null),
    [isDelivery, storeData.order_settings.has_delivery, minThreshold, maxThreshold],
  );

  const isWithinMinThreshold = useMemo(
    () => (minThreshold ? subtotal >= minThreshold : true),
    [minThreshold, subtotal],
  );

  const isWithinMaxThreshold = useMemo(
    () => (maxThreshold ? subtotal <= maxThreshold : true),
    [maxThreshold, subtotal],
  );

  const isWithinThreshold = useMemo(
    () => isWithinMinThreshold && isWithinMaxThreshold,
    [isWithinMinThreshold, isWithinMaxThreshold],
  );

  const amountTillMinThreshold = useMemo(() => minThreshold - subtotal, [minThreshold, subtotal]);

  return {
    hasDeliveryAmountThreshold,
    isWithinMinThreshold,
    isWithinMaxThreshold,
    isWithinThreshold,
    minThreshold,
    maxThreshold,
    amountTillMinThreshold,
  };
}
